import { type FC } from 'react';


import { type IconProps } from './types';

export const ArrowsProtect4OutV4Icon: FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M33 1L63 1V31" stroke="#FFDD00" strokeWidth="2" />
      <path d="M31 34H1L1 64" stroke="#FFDD00" strokeWidth="2" />
    </svg>
  );
};
